<router-outlet></router-outlet>
<div *ngIf="loading" class="sb-loader">
  <div class="sb-loader-content">
    <span class="fad fa-spinner-third fa-spin icon"></span>
    <span class="sb-loader-text">Loading, one moment...</span>
  </div>
</div>
